import { Observable, of } from 'rxjs';
import { IdentityRepository, IdentityUser, Menu } from '@model/identity';
import { IdentityOperations } from '@model/identity/operations';
import { inject } from '@angular/core';
import { WorklistsLocalStorageUsecase } from '@usecase/laboratory/worklist/worklists-local-storage.usecase';

/**
 * Implementación de repositorio de identidad para pruebas
 */
export class IdentityRepositoryImplMock extends IdentityRepository {
  user: IdentityUser = {
    userName: 'Misko Hevery',
    fullName: 'Misko Hevery',
    lastAccess: '2025-06-24',
    urlLogout: '',
    fullUrlLogout: '',
    menu: JSON.stringify([
      {
        name: 'Menu',
        menuItems: [
          {
            cdresource: 1,
            contextPath: 'home',
            name: 'Inicio',
            image: 'home',
            order: 1,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          },
          {
            cdresource: 2,
            contextPath: 'handbook/structure',
            name: 'Estructura',
            image: 'sitemap',
            order: 2,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          },
          {
            cdresource: 3,
            contextPath: 'handbook/guidelines',
            name: 'Lineamientos de aplicación',
            image: 'file-check',
            order: 3,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          },
          {
            cdresource: 4,
            contextPath: 'handbook/technologies',
            name: 'Tecnologías',
            image: 'code',
            order: 4,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          },
          {
            cdresource: 5,
            contextPath: 'handbook/components',
            name: 'Componentes',
            image: 'objects-column',
            order: 5,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          },
          {
            cdresource: 6,
            contextPath: 'handbook/tasks',
            name: 'Use Case: Tareas',
            image: 'pi pi-list-check',
            order: 6,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          }
        ]
      }
    ])
  };

  /**
   * Retorna la información del usuario
   * @returns usuario mockeado
   */
  override getUserInfo(): Observable<IdentityUser> {
    return of(this.user);
  }

  /**
   * Retorna el menú del usuario
   * @returns menú del usuario mockeado
   */
  override getUserMenu(): Promise<Menu[]> {
    return Promise.resolve(IdentityOperations.getMenu(this.user));
  }

  /**
   * Realiza el logout del usuario
   * @param fullUrlLogout url de logout
   */
  override fullLogout(fullUrlLogout: string): void {
    console.log('logged out!', fullUrlLogout);
    // Clear sensitive worklists data on logout (security remediation)
    try {
      const worklistsStorageUsecase = inject(WorklistsLocalStorageUsecase);
      worklistsStorageUsecase.delete().subscribe();
    } catch {
      // Silently fail in test context where injection may not be available
    }
  }
}
